import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import { CircularProgress, Grid } from "@mui/material";

// loader style

const Wrapper = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 9999,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

// ==============================|| Loader ||============================== //

const Loader = () => (
  <Wrapper>
    <CircularProgress value={80} size={50} />
  </Wrapper>
);

export default Loader;
